import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg, label } from "@/lib/api";

const OUTCOMES = ["conversation", "callback_requested", "resolved", "not_interested", "left_voicemail", "no_answer", "do_not_call", "wrong_number"];

export const DispositionForm = ({ call, onDone }) => {
  const [outcome, setOutcome] = useState("");
  const [notes, setNotes] = useState("");
  const [cb, setCb] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/calls/${call.id}/disposition`, { outcome, notes, callback_at: cb ? new Date(cb).toISOString() : null });
      toast.success("Disposition saved");
      onDone?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 space-y-2" data-testid={`disposition-form-${call.id}`}>
      <p className="text-sm font-medium text-amber-900">Disposition needed — {call.contact_name || "call"}</p>
      <div className="grid sm:grid-cols-2 gap-2">
        <Select value={outcome} onValueChange={setOutcome}>
          <SelectTrigger data-testid="disposition-outcome-select" className="h-9 bg-white text-xs"><SelectValue placeholder="Outcome" /></SelectTrigger>
          <SelectContent className="bg-white">{OUTCOMES.map((o) => <SelectItem key={o} value={o}>{label(o)}</SelectItem>)}</SelectContent>
        </Select>
        {outcome === "callback_requested" && (
          <Input type="datetime-local" data-testid="disposition-callback-input" className="h-9 bg-white" value={cb} onChange={(e) => setCb(e.target.value)} />
        )}
      </div>
      <Textarea rows={2} data-testid="disposition-notes" className="bg-white" placeholder="Call notes" value={notes} onChange={(e) => setNotes(e.target.value)} />
      <Button size="sm" data-testid="disposition-save-btn" disabled={!outcome || busy} onClick={save}>Save & continue</Button>
    </div>
  );
};
